import * as React from "react";
export default () => <div />;

export const teamMemberQuery = graphql`
  fragment TeamMember on PrismicTeamMemberEdge {
    node {
      id
      type
      slugs
      data {
        name
        bio {
          html
        }
        webpage {
          url
        }
        webpage_name
        primary_pic {
          url
        }
        moving_1 {
          url
        }
        moving_2 {
          url
        }
        moving_3 {
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/fragments/teamMember.js